/*
 * @Descripttion:
 * @version: 商品相关接口
 * @Author: limin
 * @Date: 2021-03-22 18:20:32
 * @LastEditors: limin
 * @LastEditTime: 2021-03-25 21:20:03
 */
import request from '../request'
const path = 'ddh.carlife.mall.goods';
export default {
  /**
   * 获取首页轮播图信息
   */
   banners(data={}) {
    data.method = `ddh.carlife.mall.banners.get`
    return request(data)
  },
  /**
   * 获取首页的商品列表标签信息
   */
  labels(data={}) {
    data.method = `${path}.labels.get`
    return request(data)
  },
  /**
   * 获取商品列表
   */
  list(data={}) {
    data.method = `${path}.list.get`
    return request(data)
  },
  /**
   * 获取商品分类
   */
  category(data={}) {
    data.method = `ddh.carlife.mall.mallclassfication.get`
    return request(data)
  },
  /**
   * 获取商品详情
   */
  detail(id) {
    let data = {
      id,
      method:`${path}.detail.get`
    }
    return request(data)
  }
}
